module.exports = __webpack_public_path__ + "static/media/placeholder-icon.ba6fe7a3.svg";